import React, { useState, useEffect } from "react";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from "react-redux";
import {
  ExternalUserSignUpTypeEnum,
  respEnum,
  VerificationTypeEnum,
} from "../../constants/appConstants";
import { getIsBookingFlow } from "../../store/bookingSlice";
import Common from "../../helpers/common";
import Swal from "sweetalert2";

const OtpModal = ({
  onClose,
  onLoginSuccess,
  forgotPasswordData,
  verificationType = VerificationTypeEnum.accountVerificationPhone,
  onChangePasswordNavigation,
}) => {
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(forgotPasswordData?.startTimer ? 120 : 0);
  const [isResendEnabled, setIsResendEnabled] = useState(!forgotPasswordData?.startTimer);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const signupData = useSelector((state) => state.signup?.signupData);
  const isBookingFlow = useSelector(getIsBookingFlow);

  // Use forgot password data if provided, otherwise use signup data
  const phoneData = forgotPasswordData || signupData;
  console.log("otp_signupData", phoneData);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setIsResendEnabled(true);
    }
  }, [timer]);

  useEffect(() => {
    if (otp.length == 6) {
      handleSubmit();
    }
  }, [otp]);

  const resendOtp = async () => {
    setIsLoading(true);
    try {
      const response = await Common.ApiService.getInstance()?.request(
        "SendVerificationCode",
        {
          phoneCode: phoneData["phoneCode"],
          phone: phoneData["phone"],
          deviceId: "string",
          type: verificationType,
        },
        "POST"
      );

      if (response?.status == respEnum.Success) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message || "OTP sent successfully",
          background: "#1a1a1a",
          color: "#fff",
          confirmButtonColor: "#007bff",
        });
        setTimer(60);
        setIsResendEnabled(false);
      } else {
        await Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.message || "Failed to send OTP",
          background: "#1a1a1a",
          color: "#fff",
          confirmButtonColor: "#007bff",
        });
      }
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to send OTP. Please try again.",
        background: "#1a1a1a",
        color: "#fff",
        confirmButtonColor: "#007bff",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleResend = () => {
    resendOtp();
  };

  const handleSubmit = async () => {
    if (otp.length !== 6) {
      await Swal.fire({
        icon: "warning",
        title: "Invalid OTP",
        text: "Please enter a valid 6-digit OTP",
        background: "#1a1a1a",
        color: "#fff",
        confirmButtonColor: "#007bff",
      });
      return;
    }

    setIsLoading(true);
    try {
      const response = await Common.ApiService.getInstance()?.request(
        "VerifyCode",
        {
          code: otp,
          type: verificationType,
          phoneCode: phoneData["phoneCode"],
          phone: phoneData["phone"],
        },
        "POST"
      );

      if (response?.status == respEnum.Success && response?.data) {
        // Check verification type to determine next action
        if (verificationType === VerificationTypeEnum.forgotPassword) {
          // Navigate to change password modal
          onChangePasswordNavigation?.(response?.data);
        } else {
          // Continue with signup flow
          signup(response?.data);
        }
      } else {
        await Swal.fire({
          icon: "error",
          title: "Verification Failed",
          text: response?.message || "Invalid OTP. Please try again.",
          background: "#1a1a1a",
          color: "#fff",
          confirmButtonColor: "#007bff",
        });
      }
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to verify OTP. Please try again.",
        background: "#1a1a1a",
        color: "#fff",
        confirmButtonColor: "#007bff",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const signup = async (id) => {
    setIsLoading(true);
    try {
      var obj = {
        ...signupData,
        vCodeId: id,
        externalusersignuptype: ExternalUserSignUpTypeEnum.Web_User,
      };
      const response = await Common.ApiService.getInstance()?.request(
        "PlayerRegister",
        obj,
        "POST"
      );

      if (response?.status == respEnum.Success) {
        if (response.data) {
          let user = response.data[0];
          Common.setToken(user.token);
          Common.setUser(user);
          global.user = user;

          await Swal.fire({
            icon: "success",
            title: "Success",
            text: "Account created successfully!",
            background: "#1a1a1a",
            color: "#fff",
            confirmButtonColor: "#007bff",
          });

          // Check if this is a booking flow
          if (isBookingFlow && onLoginSuccess) {
            onClose();
            onLoginSuccess();
          } else {
            onClose();
          }
        }
      } else {
        await Swal.fire({
          icon: "error",
          title: "Registration Failed",
          text:
            response?.message || "Failed to create account. Please try again.",
          background: "#1a1a1a",
          color: "#fff",
          confirmButtonColor: "#007bff",
        });
      }
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to create account. Please try again.",
        background: "#1a1a1a",
        color: "#fff",
        confirmButtonColor: "#007bff",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="popup">
      <div
        className="popup-inner"
        style={{
          backgroundColor: "#1a1a1a",
          color: "white",
          top: "50%",

          border: "1px solid",
          maxWidth: "400px",
          width: "90%",
          boxShadow: "0 0 20px rgba(255, 255, 255, 0.1)", // Light glow effect
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            right: "15px",
            top: "15px",
            background: "none",
            border: "none",
            color: "white",
            fontSize: "28px",
            cursor: "pointer",
            padding: "5px 10px",
            lineHeight: "1",
            zIndex: "1000",
          }}
        >
          ×
        </button>
        <h2>Enter OTP</h2>
        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          renderInput={(props) => <input {...props} />}
          inputStyle={{
            width: "40px",
            height: "40px",
            margin: "0 5px",
            fontSize: "20px",
            borderRadius: "5px",
            border: "1px solid #555", // Darker border for dark theme
            backgroundColor: "#2d2d2d", // Dark background for input
            color: "white", // White text for better contrast
          }}
        />
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <p style={{ color: "white", marginBottom: "10px" }}>
            {isResendEnabled ? (
              <span
                onClick={handleResend}
                style={{ cursor: "pointer", textDecoration: "underline" }}
              >
                Resend OTP
              </span>
            ) : (
              `Resend OTP in ${timer} seconds`
            )}
          </p>
          <button
            onClick={handleSubmit}
            style={{
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "5px",
              padding: "10px 20px",
              cursor: "pointer",
              fontSize: "16px",
            }}
            disabled={isLoading}
          >
            {isLoading ? "Verifying..." : "Verify"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OtpModal;
